import { Component, computed, inject, OnInit } from '@angular/core';
import {
    IonTabs,
    IonTabBar,
    IonTabButton,
    IonIcon,
    // IonRouterOutlet,
    IonLabel,
    // IonHeader,
    // IonToolbar,
    // IonTitle,
    // IonButtons,
} from '@ionic/angular/standalone';
import { addIcons } from 'ionicons';
import { statsChart, calculator, helpCircleOutline, shareOutline } from 'ionicons/icons';
import { Router, NavigationEnd, ActivatedRoute } from '@angular/router';
import { CommonModule } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';
import { WebrtcMeshService } from '../services/webrtc-mesh.service';
// import { LanguageSelectorComponent } from '../components/language-selector.component';
import { filter } from 'rxjs/operators';

@Component({
    selector: 'app-tabs',
    standalone: true,
    imports: [
        CommonModule,
        TranslateModule,
        IonTabs,
        IonTabBar,
        IonTabButton,
        IonIcon,
        // IonRouterOutlet,
        IonLabel,
        // IonHeader,
        // IonToolbar,
        // IonTitle,
        // IonButtons,
        // LanguageSelectorComponent
    ],
    template: `
        <ion-tabs>
            <ion-tab-bar slot="bottom">
                <ion-tab-button tab="counter" [class.tab-selected]="currentTab === 'counter'" (click)="navigateToTab('counter')">
                    <ion-icon name="calculator" aria-hidden="true"></ion-icon>
                    <ion-label>{{ 'TABS.COUNTER' | translate }}</ion-label>
                </ion-tab-button>
                <ion-tab-button tab="stats" [class.tab-selected]="currentTab === 'stats'" (click)="navigateToTab('stats')">
                    <ion-icon name="stats-chart" aria-hidden="true"></ion-icon>
                    <ion-label>{{ 'TABS.STATS' | translate }}</ion-label>
                </ion-tab-button>
                <ion-tab-button tab="connect" [class.tab-selected]="currentTab === 'connect'" (click)="navigateToTab('connect')">
                    <ion-icon name="share-outline" aria-hidden="true"></ion-icon>
                    <ion-label>{{ 'TABS.CONNECT' | translate }}</ion-label>
                </ion-tab-button>
                <ion-tab-button tab="help" [class.tab-selected]="currentTab === 'help'" (click)="navigateToTab('help')">
                    <ion-icon name="help-circle-outline" aria-hidden="true"></ion-icon>
                    <ion-label>{{ 'TABS.HELP' | translate }}</ion-label>
                </ion-tab-button>
            </ion-tab-bar>
        </ion-tabs>
    `,
    styles: [`
        .tab-selected {
            --color-selected: var(--ion-color-primary);
        }
    `]
})
export class TabsComponent implements OnInit {
    private router = inject(Router);
    private route = inject(ActivatedRoute);
    private webrtcMeshService = inject(WebrtcMeshService);

    public currentTab = 'counter';

    // Simple boolean flags for audio activity
    public isAudioBroadcasting = false;
    public hasAudioActivity = false;

    constructor() {
        addIcons({ statsChart, calculator, helpCircleOutline, shareOutline });
    }

    ngOnInit() {
        // Listen to route changes to update current tab
        this.router.events.pipe(
            filter(event => event instanceof NavigationEnd)
        ).subscribe((event: NavigationEnd) => {
            this.updateCurrentTab(event.urlAfterRedirects || event.url);
        });

        // Set initial tab based on current URL
        this.updateCurrentTab(this.router.url);
    }

    private updateCurrentTab(url: string): void {
        if (url.includes('/counter')) {
            this.currentTab = 'counter';
        } else if (url.includes('/stats')) {
            this.currentTab = 'stats';
        } else if (url.includes('/connect')) {
            this.currentTab = 'connect';
        } else if (url.includes('/help')) {
            this.currentTab = 'help';
        } else {
            this.currentTab = 'counter';
        }
    }

    navigateToTab(tab: string): void {
        // Use relative navigation for child routes
        this.router.navigate([tab], { relativeTo: this.route });
    }

    tabChanged(event: any): void {
        const selectedTab = event.tab;

        if (selectedTab !== this.currentTab) {
            this.navigateToTab(selectedTab);
        }
    }

    getTitle(): string {
        switch (this.currentTab) {
            case 'counter':
                return 'TABS.COUNTER';
            case 'stats':
                return 'TABS.STATS';
            case 'connect':
                return 'TABS.CONNECT';
            case 'help':
                return 'TABS.HELP';
            default:
                return 'TABS.COUNTER';
        }
    }
}